import { get } from "@/utils/http";
export const siteInfo = () => get("index/api/v1/site");
export const authorGuidelines = () =>
  get("/index/api/v1/site/authorGuidelines");
export const getNews = (params) =>
  get("index/api/v1/site/announcements", params);
export const getPolices = () => get("index/api/v1/site/policies");
export const getContact = () => get("index/api/v1/site/about");
export const forAuthors = () => get("index/api/v1/site/forAuthors");
export const forEditors = () => get("index/api/v1/site/forEditors");
export const forReviewers = () => get("index/api/v1/site/forReviewers");
export const getCountries = () => get("index/api/v1/access/getCountries");
